module.exports = __webpack_public_path__ + "static/sportzone-white-0ab0e81573f26f625760f5fd01d6b00b.svg";